import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Ενεργοποίηση φωτεινού θέματος' : 'Ενεργοποίηση σκοτεινού θέματος'}
      title={isDark ? 'Φωτεινό θέμα' : 'Σκοτεινό θέμα'}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex items-center justify-center w-9 h-14 rounded-l-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg hover:w-11 transition-all duration-200"
      style={{ boxShadow: '-2px 0 12px rgba(0,0,0,0.1)' }}
    >
      {isDark ? (
        <Sun className="h-5 w-5 text-amber-500" />
      ) : (
        <Moon className="h-5 w-5 text-gray-600" />
      )}
    </button>
  );
};

export default ThemeToggle;